import type { Segment } from '../state/arrangementStore'
import { renderArrangementToBuffer } from './renderer'
import { audioBufferToWavBlob } from './wav'

function isoDate(): string {
  return new Date().toISOString().slice(0, 10)
}

function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export async function exportArrangementAsWav(segments: Segment[]): Promise<void> {
  if (segments.length === 0) {
    throw new Error('Nothing to export')
  }
  const audio = await renderArrangementToBuffer(segments)
  const blob = audioBufferToWavBlob(audio)
  downloadBlob(blob, `phinstrument-${isoDate()}.wav`)
}
